export enum Axis {
  x = 'x',
  y = 'y',
  z = 'z',
}

export type Axises = 'x' | 'y' | 'z';
